export const formatEmail = (address) => {
    let [name, postfix] = address.split('@')
    return `${name} at ${postfix}`
}

export const formatRef = (ref) => (`http://infovis.cs.ucdavis.edu//${ref}/`)